module.exports = __webpack_public_path__ + "img/index.ded6d680.jpg";